import Stats from './Stats';
export { default as WalletSetup } from './components/WalletSetup';
export default Stats;
